import { Box, ListSubheader } from '@mui/material'
import React from 'react'

type Key = string | number;

interface QuickSearchResultsSectionProps<TItem> {
  title: React.ReactNode;
  results: TItem[];
  renderItem: (item: TItem, index: number) => React.ReactNode;

  /** recomendado para no depender de index como key */
  getKey?: (item: TItem, index: number) => Key;

  /** si quieres ocultar el header cuando no hay results */
  hideWhenEmpty?: boolean;

  /** custom styles */
  headerSx?: Record<string, unknown>;
  containerSx?: Record<string, unknown>;
}

export default function QuickSearchResultsSection<TItem>(
  props: QuickSearchResultsSectionProps<TItem>,
): React.ReactElement | null {
  const {
    title,
    results,
    renderItem,
    getKey,
    hideWhenEmpty = true,
    headerSx,
    containerSx,
  } = props

  if (hideWhenEmpty && results.length === 0) return null

  return (
    <Box sx={containerSx}>
      <ListSubheader
        sx={{
          bgcolor: 'grey.200',
          color: 'text.secondary',
          fontSize: '0.75rem',
          fontWeight: 700,
          textTransform: 'uppercase',
          letterSpacing: '0.5px',
          lineHeight: '32px',
          px: 2,
          py: 0.5,
          top: -8,
          ...headerSx,
        }}
      >
        {title}
      </ListSubheader>

      {results.map((item, index) => (
        <React.Fragment key={getKey ? getKey(item, index) : index}>
          {renderItem(item, index)}
        </React.Fragment>
      ))}
    </Box>
  )
}
